<script *ngIf="application=='meinkonto'" src="app.meinkonto.ts"></script>
<script *ngIf="application=='kraft'" src="app.makpakkraft.main.ts"></script>
<script *ngIf="application=='sach'" src="app.uploadpakete.main.ts"></script>

  <td-layout *ngIf="application=='sach'">
    <td-layout-nav toolbarTitle="Paket Cockpit">
      <mat-sidenav-container class="td-layout-nav-list" fullscreen fix>
        <mat-sidenav #sidenav mode="side">
          <mat-nav-list td-sidenav-content>
          </mat-nav-list>
        </mat-sidenav>
        <router-outlet></router-outlet>
      </mat-sidenav-container>
      <td-layout-footer>
        <div layout="row" layout-align="start center">
          <span class="mat-caption">Allianz &copy; 2018 PaketCockpit. Version {{getVersion()}}</span>
        </div>
      </td-layout-footer>
    </td-layout-nav>
  </td-layout>

  <td-layout *ngIf="application=='kraft'">
    <app-index-kraft [version]="getVersion()"></app-index-kraft>
  </td-layout>

<td-layout *ngIf="application=='meinkonto'">
  <td-layout-nav toolbarTitle="Paket Cockpit">
    <mat-sidenav-container class="td-layout-nav-list" fullscreen fix>
      <mat-sidenav #sidenav mode="side">
        <mat-nav-list td-sidenav-content>
        </mat-nav-list>
      </mat-sidenav>
      <router-outlet></router-outlet>
    </mat-sidenav-container>
    <td-layout-footer>
      <div layout="row" layout-align="start center">
        <span class="mat-caption">Allianz &copy; 2020 Mein Konto. Version 1.0</span>
      </div>
    </td-layout-footer>
  </td-layout-nav>
</td-layout>



